import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/safe/role',
  owner: '/home',
  authority: 'role',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};